exports = module.exports = require("../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.quill-editor img {\n  max-width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/happypack/loader.js?id=css!./~/vue-loader/lib/style-compiler?{"id":"data-v-3ddf70ce","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-quill-editor/src/editor.vue
// module id = 518
// module chunks = 23